import React, { useState } from "react";
import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  useColorModeValue,
  useToast,
  RadioGroup,
  Radio,
  Stack,
  Divider,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { PublicNavbar } from "../layout/PublicNavbar";
import { Footer } from "../layout/Footer";
import { paymentsAPI } from "../../services";

interface PlanOption {
  id: string;
  name: string;
  price: number;
  period: "MONTHLY" | "YEARLY";
}

export const SwitchPlan: React.FC = () => {
  const [selectedPlan, setSelectedPlan] = useState<string>("");
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const toast = useToast();
  const bgColor = useColorModeValue("gray.50", "gray.900");

  const planOptions: PlanOption[] = [
    {
      id: "monthly",
      name: t("pricing.tiers.subscription.name"),
      price: 20,
      period: "MONTHLY",
    },
    {
      id: "yearly",
      name: t("pricing.tiers.subscription.name"),
      price: 180,
      period: "YEARLY",
    },
  ];

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!selectedPlan) return;

    setIsLoading(true);
    const plan = planOptions.find((p) => p.id === selectedPlan);
    if (!plan) return;

    try {
      const payment = await paymentsAPI.createSubscriptionPayment(
        plan.price,
        `${plan.name} - ${plan.period.toLowerCase()} assinatura`
      );
      // Redirect to payment URL
      window.location.href = payment.paymentUrl;
    } catch (error) {
      console.error("Error creating subscription:", error);
      toast({
        title: t("payments.switchPlan.error"),
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box minH="100vh" display="flex" flexDirection="column">
      <PublicNavbar />

      <Box flex="1" bg={bgColor} py={20}>
        <Container maxW="container.sm">
          <VStack spacing={8} align="stretch">
            <VStack spacing={4} textAlign="center">
              <Heading
                size="xl"
                fontFamily="Nasalization"
                bgGradient="linear(to-r, brand.primary, brand.secondary)"
                bgClip="text"
              >
                {t("payments.switchPlan.title")}
              </Heading>
              <Text
                fontSize="lg"
                color={useColorModeValue("gray.600", "gray.400")}
              >
                {t("payments.switchPlan.subtitle")}
              </Text>
            </VStack>

            <Box
              as="form"
              onSubmit={handleSubmit}
              bg={useColorModeValue("white", "gray.800")}
              p={8}
              borderRadius="xl"
              shadow="base"
            >
              <VStack spacing={6}>
                <RadioGroup
                  onChange={setSelectedPlan}
                  value={selectedPlan}
                  width="full"
                >
                  <Stack direction="column" spacing={4}>
                    {planOptions.map((plan) => (
                      <Box
                        key={plan.id}
                        p={4}
                        borderWidth="1px"
                        borderRadius="md"
                        borderColor={
                          selectedPlan === plan.id ? "brand.500" : "gray.200"
                        }
                        _hover={{ borderColor: "brand.500" }}
                        cursor="pointer"
                      >
                        <Radio value={plan.id} width="full">
                          <Stack
                            direction="row"
                            justify="space-between"
                            width="full"
                          >
                            <Text fontWeight="medium">
                              {plan.period === "YEARLY"
                                ? t("pricing.yearly")
                                : t("pricing.monthly")}
                            </Text>
                            <Text fontWeight="bold">
                              ${plan.price}
                              {plan.period === "YEARLY"
                                ? t("pricing.tiers.subscription.yearlyPeriod")
                                : t("pricing.tiers.subscription.period")}
                            </Text>
                          </Stack>
                        </Radio>
                      </Box>
                    ))}
                  </Stack>
                </RadioGroup>

                <Divider />

                <Button
                  type="submit"
                  colorScheme="brand"
                  size="lg"
                  width="full"
                  isLoading={isLoading}
                  loadingText={t("payments.switchPlan.processing")}
                  // isDisabled={!selectedPlan}
                  isDisabled={true}
                >
                  (desabilitado)
                  {t("payments.switchPlan.submit")}
                </Button>
              </VStack>
            </Box>
          </VStack>
        </Container>
      </Box>

      <Footer />
    </Box>
  );
};
